import React, { useState } from "react";
import { connect } from "react-redux";

// @material-ui/core components
// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { Payment, Visibility } from "@mui/icons-material";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import Debtor from "../../licensing/Models/Debtor";
import SyncButton from "../../components/SyncButton";
import TextFilter from "../../components/Filters/TextFilter";
import { useNavigate } from "react-router";

function SubsDebtorsIndex(props) {
  const navigate = useNavigate();

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tKey={"Debtors"} />} />

      <AuthenticationWrapper
        child={
          <SyncButton
            onClick={() => {
              return Debtor.importDebtors();
            }}
          />
        }
        permissionKey={"debtors.import"}
      />

      <GridContainer>
        <GridItem md={4} xs={12}>
          <TextFilter
            field={"company_name"}
            fieldKey={"debtors:company_name"}
            operator={"like"}
            placeholder={getTranslation("Filter on debtor")}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          <JamezzTable
            actions={[
              {
                icon: Visibility,
                tooltip: <TranslationWrapper tKey={"Open debtor"} />,
                action: (row) => navigate(`/manager/subsdebtors/${row[0]}/edit`),
              },
            ]}
            dataMapping={[
              { dbfield: "id", editable: false },
              { dbfield: "company_name", editable: false },
              { dbfield: "email_address", editable: false },
            ]}
            dbfields={"id,email_address,company_name"}
            delete={false}
            editLink={false}
            fetchUrl={"core/subsDebtor"}
            filters={props.filters}
            headerIcon={<Payment />}
            headers={[
              {
                label: getTranslation("#"),
                sortable: true,
                sortKey: "id",
              },
              {
                label: getTranslation("Company"),
                sortable: true,
                sortKey: "company_name",
              },
              {
                label: getTranslation("Email address"),
                sortable: false,
              },
            ]}
            reduxKey={"subs_debtor"}
            tableTitle={<TranslationWrapper tKey={"Debtors"} />}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

SubsDebtorsIndex.contextType = DialogContext;

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["debtors:company_name"]) {
    filters["debtors:company_name"] = state.filtersV2["debtors:company_name"];
  }
  return {
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubsDebtorsIndex);
